import React, { Component } from 'react';
import * as actions from 'actions';
import { connect } from 'react-redux';
const CryptoJS = require('crypto-js');
import MessageList from './MessageList';
import { cynoEncryptionKey } from '../../utils/database/database-utils.js';
import MessageBackEnd from 'utils/ChatBackend';
const { sendMessage } = MessageBackEnd;
import isEqual from 'lodash/isEqual';
import uniq from 'lodash/uniq';

import AddPhoto from 'material-ui/svg-icons/image/add-a-photo';
import Send from 'material-ui/svg-icons/content/send';
import UpArrow from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
const moment = require('moment-timezone');

import { toArray } from 'utils/lodashUtils';
import MessageSubmitFormSC from './MessageSubmitFormSC';
import IconCircleWrapperSC from '../Icons/Wrappers/IconCircleWrapperSC';
import TextInputSC from './TextInputSC';

import { checkIfReceiverIncludesStatuses } from 'utils/serviceUtils';
import SendMessageButton from '../Button/SendMessageButton';
import { constants } from '../../constants';
import { getInteractionWidth } from 'utils/layoutUtils';
import { getMaxHeightChat } from 'utils/layoutUtils';

import Link from 'react-router-dom/Link';
import { Button } from 'components/Button/Button';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { fileEncryption, encryptMessage } from '../../utils/security';
import { resizeImage, dataURItoFile } from '../../utils/imageProcessing';

class Chat extends Component {
    constructor(props) {
        super(props);

        this.state = {
            allowedToLoadPrevious: false,
            buttonColor: '#C6CACC',
            channel: null,
            height: null,
            inputHeight: 40,
            messages: [],
            messagesLoaded: false,
            service: null,
            width: null,
        };

        let mounted = false;
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);

        const { channel, client, service, channelEncryptionKey } = this.props;
        // console.log('All Props @ chat component: ', this.props);
        // console.log('%cCHAT CHANNEL','color: aqua', this.props.channel);

        // LOAD ALL MESSAGES FROM DB ON MOUNT
        this.props
            .loadMessages(
                () => {
                    return null;
                },
                client.uid,
                service._id,
                service.provider,
                channel,
                'message',
                channelEncryptionKey,
            )
            .then(messages => {
                // console.log('CDM & MESSAGES FROM REDUX', messages);

                this.setState({
                    allowedToLoadPrevious: true,
                    messagesLoaded: true,
                });
                this.scrollToBottom();
            })
            .catch(console.log);
    }

    componentWillReceiveProps(nextProps) {
        const { channel, client, service, channelEncryptionKey } = nextProps;
        if (this.props.channel !== channel) {
            // ERASE MESSAGES FROM PREVIOUS SELECTED THREAD
            this.setState({
                messages: [],
            });

            // LOAD MESSAGES FOR WHEN NEW CLIENT/SERVICE ARE SELECTED
            this.props
                .loadMessages(
                    () => {
                        return null;
                    },
                    client.uid,
                    service._id,
                    service.provider,
                    channel,
                    'message',
                    channelEncryptionKey,
                )
                .then(messages => {
                    // console.log('MESSAGES @ LOAD MESSAGES @ CWRP', messages, typeof messages);

                    this.setState({
                        allowedToLoadPrevious: true,
                        messagesLoaded: true,
                    });
                    this.scrollToBottom();
                })
                .catch(console.log);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    };

    onMessageSubmit = async e => {
        e.preventDefault();

        const input = this.state.messageText;
        const photoInput = this.messagePhoto;

        if (!input) {
            return false;
        }

        await this.pushMessage(
            this.props.userData.uid,
            input,
            this.state.photoUpload && this.state.photoUpload.file,
        );

        photoInput.value = '';

        this.setState({
            messageText: '',
            photoUpload: {
                file: null,
                preview: null,
            },
        });

        return true;
    };

    pushMessage(recipient, messageText, photoFile) {
        const prevState = this.state;
        const { userData, service, channel, selectedClient } = this.props;
        const { photoUpload } = this.state;
        const now = moment.utc().format('x');
        // console.log('PhotoUpload @ pushMessage - ChatComponent', photoUpload);

        return encryptMessage(this.props.channelEncryptionKey, messageText, photoFile).then(
            response => {
                const newMessage = {
                    createdAt: now,
                    photoURL: response.encFile ? URL.createObjectURL(response.encFile) : null,
                    senderId: userData.uid,
                    senderName: `${userData.firstName} ${userData.lastName}`,
                    text: response.encMessage,
                };
                // console.log('Message-newMessage', newMessage);
                prevState.messages.push(newMessage);

                sendMessage({
                    createdAt: now,
                    message: newMessage,
                    photoFile: response.encFile,
                    receiverId: selectedClient ? selectedClient.uid : service.provider,
                    senderId: userData.uid,
                    serviceId: this.props.service._id,
                    threadId: channel,
                    type: 'message',
                    uploadDoneCb: () => {
                        console.log(
                            `%cFiring Action Creator for Photo Upload`,
                            'color: greenyellow',
                        );
                        this.props.setPhotoMessageUploadingStateTo(false);
                    },
                });
                if (this.state.photoUpload && this.state.photoUpload.preview) {
                    // IF THERE IS A PHOTO SUBMITTED THEN SHOW THE UPLOAD SPINNER
                    this.props.setPhotoMessageUploadingStateTo(true);
                }
                this.setState({
                    shouldScrollToBottom: true,
                });
            },
        );
    }

    resetShouldScrollToBottom = () => {
        this.setState({
            shouldScrollToBottom: false,
        });
    };

    scrollToBottom = () => {
        // TODO: =========
        // might be good to show an indicator when a new message arrives while the user is scrolled up looking at chat history so they know to scroll down to view the new message.
        // I dont like the idea of forcing a scroll down when they are viewing old messages.
        // They can click on the indicator to scroll to the bottom/new messages and hide the indicator
        // ===============
        const scrollHeight = this.chat.scrollHeight;
        const height = this.chat.clientHeight;
        const maxScrollTop = scrollHeight - height;
        this.chat.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
    };

    loadMoreMessages = () => {
        return new Promise((resolve, reject) => {
            this.props.loadPastMessages(
                messArray => {
                    // console.log('messArray', messArray);
                    resolve(messArray);
                },
                this.props.service.provider,
                this.props.messagesRedux && this.props.messagesRedux[0]._id,
                this.props.channel,
            );
        });
    };

    // componentDidUpdate(prevProps, prevState) {
    //     // if (prevState.messages.length > 0 && this.state.messages.length > 0 && this.state.messages.length === prevState.messages.length) {
    //     //     console.log('DONE LOADING MESSAGES');
    //     // }
    // }

    handlePhotoUpload = event => {
        // show photo thumb that was uploaded
        const file = event.target.files[0];
        const photoPreviewURL = URL.createObjectURL(file);

        this.setState({
            photoUpload: {
                file: file,
                preview: photoPreviewURL,
            },
        });
    };

    handleSetButtonColor = e => {
        if (e.target.value.length > 0) {
            this.setState({
                buttonColor: '#4AC4D1',
            });
        } else {
            this.setState({
                buttonColor: '#C6CACC',
            });
        }
    };

    handleInputChange = e => {
        this.setState({
            messageText: e.target.value,
        });
    };

    render() {
        const {
            channel,
            filteredServices,
            filteredClients,
            selectedClient,
            service,
            userData,
            isModulePartOfService,
        } = this.props;
        const filteredReceivers = {
            activeReceivers: filteredClients.activeClients || filteredServices.activeServices,
            inactiveReceivers: filteredClients.inactiveClients || filteredServices.inactiveServices,
            pendingReceivers: filteredClients.pendingClients || filteredServices.pendingServices,
        };

        const isProvider = userData && userData.provider;

        // console.log('FILTERED RECEIVERS @ RENDER OF CHAT COMP', filteredReceivers);

        // const receiver = selectedClient || service;
        let receiver = {};
        if (isProvider) {
            receiver = selectedClient;
        } else if (!isProvider) {
            receiver = service;
        }

        // console.log('chat-filteredReceivers', filteredReceivers)
        // console.log('chat-filteredClients', filteredClients)
        // console.log('chat-filteredServices', filteredServices)
        // console.log('chat-selectedClient', selectedClient)
        // console.log('chat-service', service)
        // console.log('chat-receiver', receiver)
        // console.log('chat-userData', userData)
        // console.log('chat-selectedClient', selectedClient)
        // console.log('chat-props', this.props)
        // console.log('chat-isModulePartOfService', isModulePartOfService)
        // console.log('chat-checkIfReceiverIncludesStatuses', checkIfReceiverIncludesStatuses(receiver, ['active', 'pending'], filteredReceivers))
        // console.log('chat-checkIfReceiverIncludesStatuses-not-Provider', (!isProvider && checkIfReceiverIncludesStatuses(receiver, ['active', 'pending'], filteredReceivers)))
        // console.log('chat-checkIfReceiverIncludesStatuses-is-Provider', isProvider || (!isProvider && checkIfReceiverIncludesStatuses(receiver, ['active', 'pending'], filteredReceivers) &&  isModulePartOfService))

        if (this.state.messages && this.state.messages.length > 0) {
            // console.log('LOAD MORE?', this.state.messages[this.state.messages.length - 1].id, this.state.messages.length, this.state.messages.length - 1 /*this.state.messages[this.state.messages.length - 1].id*/);
        }

        // console.log('isProvider?', !userData.provider);
        // console.log(
        //     'Service includes active or pending status?',
        //     !checkIfReceiverIncludesStatuses(
        //         receiver,
        //         ['active', 'pending'],
        //         filteredReceivers,
        //     ),
        // );
        // console.log(
        //     'isModuile part of serfvice offerienfg?',
        //     isModulePartOfService,
        // );

        return (
            <div style={styles.outerChatContainerStyles}>
                {this.state.height && userData && (
                    <MessageList
                        // maxHeight={ getMaxHeightChat(this.state, userData, this.state.inputHeight) }
                        // maxHeight={ (this.state.height && this.state.height > 400) ? this.state.height - 340 - ((this.state.messages.length > 19) ? 50 : 0) : 100 }
                        // messages={this.state.messages} // Boolean: list of message objects
                        // showSenderName
                        loadMoreMessages={this.loadMoreMessages}
                        // allowedToLoadPrevious={this.state.allowedToLoadPrevious}
                        messagesLoaded={this.state.messagesLoaded}
                        shouldScrollToBottom={this.state.shouldScrollToBottom}
                        resetShouldScrollToBottom={this.resetShouldScrollToBottom}
                        userData={userData}
                        selectedClient={selectedClient}
                        selectedService={service}
                    />
                )}
                {!userData.provider &&
                    !checkIfReceiverIncludesStatuses(
                        receiver,
                        ['active', 'pending'],
                        filteredReceivers,
                    ) &&
                    isModulePartOfService && (
                        <React.Fragment>
                            <p
                                style={{
                                    textAlign: 'center',
                                    fontSize: 14,
                                    color: 'darkgray',
                                    fontWeight: 'bold',
                                    margin: '5% auto',
                                    padding: '0 5%',
                                }}
                            >
                                Sending messages is not available for expired services.
                            </p>

                            {/* TEMPORARILY DEACTIVE REPEATS UNTIL PUCHASE BYPASS IS DONE */}
                            {/* <p style={{ textAlign: 'center', fontSize: 14 }}>If you enjoyed this service, you can repeat it by clicking below:</p>
                        
                        <Link style={{ textDecoration: 'none', margin: '0 auto' }} to={`/service/detail/${service._id}`}>
                            <Button>
                                <FontAwesomeIcon 
                                    icon={['fas', 'redo-alt']}
                                    style={{ marginRight: 15 }}
                                    size={10}
                                /> 
                                Repeat Service
                            </Button>
                        </Link> */}

                            {/* ONCE RATINGS ARE DONE THIS CAN BE UNCOMMENTED */}
                            {/* <p style={{ textAlign: 'center', fontSize: 14 }}>OR</p>
                        <Button backgroundColor="#0ad6df">
                            <FontAwesomeIcon 
                                icon={['fas', 'comment']}
                                style={{ marginRight: 15 }}
                                size={10}
                            /> 
                            Leave Feedback
                        </Button> */}
                        </React.Fragment>
                    )}
                {!isModulePartOfService && (
                    <p
                        style={{
                            textAlign: 'center',
                            fontSize: 14,
                            color: 'darkgray',
                            fontWeight: 'bold',
                            margin: '5% auto',
                            padding: '0 5%',
                        }}
                    >
                        Sending messages is not available outside of video consultations for this
                        service.
                    </p>
                )}
                {isProvider &&
                    !checkIfReceiverIncludesStatuses(
                        receiver,
                        ['active', 'pending'],
                        filteredReceivers,
                    ) &&
                    isModulePartOfService && (
                        <React.Fragment>
                            <p
                                style={{
                                    textAlign: 'center',
                                    fontSize: 14,
                                    color: 'darkred',
                                    fontWeight: 'bold',
                                    margin: '0 auto',
                                    padding: '0 5%',
                                }}
                            >
                                This service is no longer active.
                            </p>
                            <p
                                style={{
                                    textAlign: 'center',
                                    fontSize: 14,
                                    color: 'darkred',
                                    fontWeight: 'bold',
                                    margin: '5% auto',
                                    padding: '0 5%',
                                    marginTop: 5,
                                }}
                            >
                                Clients will not be able to respond to your messages.
                            </p>
                        </React.Fragment>
                    )}
                {(isProvider ||
                    (!isProvider &&
                        checkIfReceiverIncludesStatuses(
                            receiver,
                            ['active', 'pending'],
                            filteredReceivers,
                        ))) &&
                    isModulePartOfService && (
                        <MessageSubmitFormSC
                            onSubmit={e => this.onMessageSubmit(e)}
                            // width={getInteractionWidth(this.state)}
                            // maxWidth={constants.layout.InteractionPanel.maxWidth}
                            height={this.state.inputHeight}
                        >
                            {/* <label htmlFor="photo" style={{ position: 'absolute', bottom: 0, zIndex: 99, cursor: 'pointer' }}> */}
                            <label htmlFor="photo" style={{ cursor: 'pointer' }}>
                                <AddPhoto
                                    style={{
                                        paddingLeft: 20,
                                        cursor: 'pointer',
                                    }}
                                />{' '}
                                {/* if a webcam is detected show a opoup giving choice of file upload or web cam */}
                            </label>
                            {this.state.photoUpload && this.state.photoUpload.preview && (
                                // <img src={this.state.photoUpload && this.state.photoUpload.preview} alt="" style={{ width: 30, height: 30, position: 'absolute', bottom: 0, transform: 'translate(30px, -5px)', zIndex: 100 }}/>
                                <img
                                    src={this.state.photoUpload && this.state.photoUpload.preview}
                                    alt=""
                                    style={{
                                        paddingLeft: 15,
                                        width: 30,
                                        height: 30,
                                    }}
                                />
                            )}
                            <input
                                style={{ display: 'none' }}
                                type="file"
                                accept="image/*"
                                id="photo"
                                ref={m => {
                                    this.messagePhoto = m;
                                }}
                                onChange={this.handlePhotoUpload}
                            />
                            <TextInputSC
                                onKeyUp={this.handleSetButtonColor}
                                value={this.state.messageText}
                                onChange={this.handleInputChange}
                                className="messageInput"
                                placeholder="Type a message..."
                                style={{ ...styles.chatInputStyles }}
                            />
                            {/* <button type="submit" style={{ backgroundColor: 'transparent', borderWidth: 0, position: 'absolute', bottom: 0, transform: (this.state.photoUpload && this.state.photoUpload.preview) ? 'translateX(-80px)' : 'translateX(-40px)', zIndex: 99 }}> */}
                            <button
                                type="submit"
                                style={{
                                    backgroundColor: 'transparent',
                                    borderWidth: 0,
                                    paddingRight: 20,
                                }}
                            >
                                <SendMessageButton buttonBackgroundColor={this.state.buttonColor} />
                            </button>
                        </MessageSubmitFormSC>
                    )}
            </div>
        );
    }
}

// const { width: viewportWidth, height: viewportHeight } = Dimensions.get('window');
const styles = {
    button: {
        backgroundColor: '#fff',
        borderColor: '#1D2129',
        borderRadius: 20,
        borderStyle: 'solid',
        borderWidth: 2,
        color: '#1D2129',
        fontSize: 18,
        fontWeight: '300',
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
    },
    chatInputStyles: {
        border: 'none',
        borderTop: '0px solid #ddd',
        display: 'flex',
        flex: 1,
        fontSize: '16px',
        outlineWidth: 0,
        paddingLeft: 30,
    },
    innerChatContainerStyles: {
        borderRadius: '4px',
        boxShadow: '0 20px 20px rgba(0, 0, 0, .08)',
        margin: '0 auto',
        padding: '0px 0px 0px 0px',
    },
    outerChatContainerStyles: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        overflowY: 'scroll',
    },
    selected: {
        backgroundColor: '#0084FF',
        borderColor: '#0084FF',
        color: '#fff',
    },
};

const mapStateToProps = ({ chat, client, provider, service }) => {
    // console.log('GOT NEW CHANNEL?', chat.messageThread);

    return {
        channel: chat.messageThread,
        channelEncryptionKey: chat.msgKey,
        filteredClients: {
            activeClients: provider.activeClients,
            inactiveClients: provider.inactiveClients,
            pendingClients: provider.pendingClients,
        },
        filteredServices: {
            activeServices: service.activeServices,
            inactiveServices: service.inactiveServices,
            pendingServices: service.pendingServices,
        },
        messagesRedux: chat.messages,
        selectedClient: provider.selectedClient,
        userData: client.clientData,
    };
};

export default connect(
    mapStateToProps,
    actions,
)(Chat);



// WEBPACK FOOTER //
// ./src/js/components/Chat/ChatComponent.jsx